// packages/content/src/tuning/time.ts
import type { TuningBank } from '../schema/tuning';
export default {
  dayStartHour: 5, constructionHour: 5, mailRoundHours: [9, 17], housekeepingMinute: 310, homeLetterWeekday: 0,
  jobRetryBaseMs: 60_000, jobMaxAttempts: 5,
  presetStarts: { morning: 300, midday: 660, golden: 1020, dusk: 1170 },   // lighting and music schedule (minutes of day)
  lightBlendMinutes: 60,
} as const satisfies TuningBank;
